// imports
import * as $ from 'jquery';

let bookmarks;

(window as any).unloadBookmarks = unloadBookmarks;

export function initialize(): void {
    $('.js-load-bookmarks').on('click', onShowBookmarks);
};

function unloadBookmarks(): void {
    bookmarks = null;
}

function onShowBookmarks(event: any, params: any): void {
    $('.sidebar').addClass('sidebar--sub-level');
    $(".subNavigation").addClass("selected--bookmarks");
    $(".pIFavorites").addClass("selectedItem");
    $("#myfavorites_sidebar").addClass("selectedItem").focus();

    $("#js-react-bookmarks-expanded .coverages__tabs-container .coverages__tab:first-child").click().focus();

    $(".pIUser").hide();
    $(".pIRecentlyRead").hide();
    $(".pINotes").hide();
    $(".pIWatched").hide();

    $("#mynotes_sidebar").removeClass("selectedItem");
    $("#mylatestvisited_sidebar").removeClass("selectedItem");
    $("#mycoverage_sidebar").removeClass("selectedItem");

}
